import { render, staticRenderFns } from "./JourneyConnectionPropertyBase.vue?vue&type=template&id=171ed0d8&scoped=true&"
import script from "./JourneyConnectionPropertyBase.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionPropertyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ed0d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171ed0d8')) {
      api.createRecord('171ed0d8', component.options)
    } else {
      api.reload('171ed0d8', component.options)
    }
    module.hot.accept("./JourneyConnectionPropertyBase.vue?vue&type=template&id=171ed0d8&scoped=true&", function () {
      api.rerender('171ed0d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/JourneyConnectionPropertyBase.vue"
export default component.exports